<template>
  <div class="MainCountain">
    <div
      v-show="!ShowMenu"
      style="padding: 30px;position: absolute;width: 100%"
    >
      <div
        v-if="ShowBackBtn"
        class="backtohome2 animated fadeInRight"
        style="margin-left: 30px"
        v-on:click="goBack"
      >
        <Icon size="30" type="ios-arrow-back" />
        BACK
      </div>
      <div
        class="hunbermenu"
        :class="{ whiteicon: iconIsWhite }"
        v-on:click="openNav"
      >
        <Icon size="60" type="md-menu" />
      </div>
    </div>

    <div v-show="ShowMenu" style="width: 100%;">
      <div class="backbtn">
        <div class="backtohome" v-on:click="goIn(4)">
          <Icon size="30" type="ios-arrow-back" />
          CLOSE
        </div>
      </div>
      <Row class="MainSelect">
        <Col class="menucol">
          <div v-bind:class="classOne" v-on:click="goIn(0)">
            <div class="textarea">
              <div class="Sid">01</div>
              <div class="dvline"></div>
              <div class="title">關於我們</div>
            </div>
          </div>
        </Col>
        <Col class="menucol">
          <div v-bind:class="classTwo" v-on:click="goIn(1)">
            <div class="textarea">
              <div class="Sid">02</div>
              <div class="dvline"></div>
              <div class="title">放射線治療</div>
            </div>
          </div>
        </Col>
        <Col class="menucol">
          <div v-bind:class="classThree" v-on:click="goIn(2)">
            <div class="textarea">
              <div class="Sid">03</div>
              <div class="dvline"></div>
              <div class="title">精準放射治療</div>
            </div>
          </div>
        </Col>
        <Col class="menucol">
          <div v-bind:class="classFive" v-on:click="goIn(6)">
            <div class="textarea">
              <div class="Sid">04</div>
              <div class="dvline"></div>
              <div class="title">適應性治療</div>
            </div>
          </div>
        </Col>
        <Col class="menucol">
          <div v-bind:class="classFour" v-on:click="goIn(3)">
            <div class="textarea">
              <div class="Sid">05</div>
              <div class="dvline"></div>
              <div class="title">質子治療</div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    NavStatus: Boolean,
    ShowBackBtn: Boolean,
    Way: Number,
    BackPath: String,
    WhiteIcon: Boolean
  },
  components: {},
  computed: {
    // 首頁由 Home 依底圖亮度傳入；其餘內頁一律黑底，固定用白色
    iconIsWhite() {
      const path = (this.$route && this.$route.path) || "";
      return this.WhiteIcon || path.toLowerCase() !== "/home";
    }
  },
  data() {
    return {
      ShowMenu: false,
      classOne: {
        selecttion: true,
        selecttionIn1: false
      },
      classTwo: {
        selecttion: true,
        selecttionIn2: false
      },
      classThree: {
        selecttion: true,
        selecttionIn3: false
      },
      classFour: {
        selecttion: true,
        selecttionIn4: false
      },
      classFive: {
        selecttion: true,
        selecttionIn5: false
      }
    };
  },
  watch: {
    ShowMenu: function() {
      this.InOrOut(this.ShowMenu);
    }
  },
  methods: {
    openNav() {
      console.log("open");
      this.ShowMenu = !this.ShowMenu;
      this.$emit("cellback", { status: this.ShowMenu });
    },
    InOrOut(b) {
      let self = this;
      if (b) {
        setTimeout(function() {
          self.classOne["selecttion"] = !b;
          self.classOne["selecttionIn1"] = b;
          self.classTwo["selecttion"] = !b;
          self.classTwo["selecttionIn2"] = b;
          self.classThree["selecttion"] = !b;
          self.classThree["selecttionIn3"] = b;
          self.classFour["selecttion"] = !b;
          self.classFour["selecttionIn4"] = b;
          self.classFive["selecttion"] = !b;
          self.classFive["selecttionIn5"] = b;
        }, 1);
      } else {
        self.ShowMenu = false;
        self.$emit("cellback", { status: this.ShowMenu });
        self.classOne["selecttion"] = !b;
        self.classOne["selecttionIn1"] = b;
        self.classTwo["selecttion"] = !b;
        self.classTwo["selecttionIn2"] = b;
        self.classThree["selecttion"] = !b;
        self.classThree["selecttionIn3"] = b;
        self.classFour["selecttion"] = !b;
        self.classFour["selecttionIn4"] = b;
        self.classFive["selecttion"] = !b;
        self.classFive["selecttionIn5"] = b;
      }
    },
    goBack() {
      if (this.BackPath) {
        this.$router.replace(this.BackPath);
        this.InOrOut(false);
      } else {
        this.goIn(this.Way);
      }
    },
    goIn(v) {
      switch (v) {
        case 0:
          this.$router.replace("/About");
          this.InOrOut(false);
          break;
        case 1:
          this.$router.replace("/Radiation");
          this.InOrOut(false);
          break;
        case 2:
          this.$router.replace("/Technology");
          this.InOrOut(false);
          break;
        case 3:
          this.$router.replace("/Proton");
          this.InOrOut(false);
          break;
        case 4:
          this.InOrOut(false);
          break;
        case 5:
          this.$router.replace("/Home");
          this.InOrOut(false);
          break;
        case 6:
          this.$router.replace("/Adaptive");
          this.InOrOut(false);
          break;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.MainCountain {
  font-weight: 400;
  color: black;
  position: absolute;
  width: 1920px;
}
/* 底圖較亮時，漢堡選單轉白避免被圖片吃掉 */
.whiteicon {
  color: #fff;
}

.hunbermenu {
  width: 50px;
  height: 50px;
  float: right;
  /*background-color: black;*/
  /*position: absolute;*/
}

.backbtn {
  position: absolute;
  width: 100%;
  height: 1080px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.backtohome {
  border-radius: 30px;
  line-height: 55px;
  font-size: 1.5rem;
  color: #fff;
  margin-bottom: 60px;
  margin-left: auto;
  margin-right: auto;
  z-index: 2;
  position: relative;
  width: 180px;
  height: 50px;
  border: 20px;
  background-color: black;
}

.backtohome2 {
  float: left;
  border-radius: 30px;
  line-height: 55px;
  font-size: 1.5rem;
  color: #fff;
  position: relative;
  width: 150px;
  height: 50px;
  border: 20px;
  background-color: black;
}

.selecttion {
  width: 100%;
  height: 1080px;
  opacity: 0;
  transition: all 0.8s;
}

.selecttionIn1 {
  text-align: center;
  background-image: url("../assets/M01.png");
  background-repeat: no-repeat;
  background-position: center;
  opacity: 1;
  height: 1080px;
  transition: all 0.5s;
  transition-delay: 0s;
}

.selecttionIn2 {
  background-image: url("../assets/M02.png");
  background-repeat: no-repeat;
  background-position: center;
  opacity: 1;
  height: 1080px;

  transition: all 0.6s;
  transition-delay: 0.1s;
}

.selecttionIn3 {
  background-image: url("../assets/M03.png");
  background-repeat: no-repeat;
  background-position: center;

  opacity: 1;
  height: 1080px;
  transition: all 0.7s;
  transition-delay: 0.2s;
}

.selecttionIn5 {
  background-image: url("../assets/M05.png");
  background-repeat: no-repeat;
  background-position: center;
  opacity: 1;
  height: 1080px;
  transition: all 0.8s;
  transition-delay: 0.3s;
}

.selecttionIn4 {
  background-image: url("../assets/M04.png");
  box-shadow: black;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 1;
  height: 1080px;
  transition: all 0.9s;
  transition-delay: 0.4s;
}

.menucol {
  float: left;
  width: 20%;
}

.MainSelect {
  z-index: 1;
  position: absolute;
  width: 1920px;
}

.textarea {
  font-size: 1.5rem;
  margin-left: auto;
  margin-right: auto;
  width: 200px;
  padding-top: 600px;
  font-weight: 300;
}

.dvline {
  margin: 20px 0px;
  background-color: #df5e04;
  height: 2px;
  width: 200px;
}

.Sid {
  font-family: "MyCustomFont", "Noto Sans TC", "Helvetica Neue", Helvetica,
    Arial, sans-serif;

  color: #df5e04;
  font-size: 6rem;
}
.title {
  font-size: 2.3rem;
  font-weight: 400;
  color: white;
  white-space: nowrap;
}
</style>
